import { Component, inject, signal } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { CvxHeaderComponent } from "./shared/components/cvx-header/cvx-header.component";
import { CvxNavbarComponent } from "./shared/components/cvx-navbar/cvx-navbar.component";
import { CvxMainComponent } from "./shared/components/cvx-main/cvx-main.component";
import { CvxAsideLeftComponent } from "./shared/components/cvx-aside-left/cvx-aside-left.component";
import { CvxFooterComponent } from "./shared/components/cvx-footer/cvx-footer.component";
import { APP_CONFIG } from '@shared/constants/app-config.const';
import { AuthService } from './services/auth/auth.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CvxHeaderComponent, CvxNavbarComponent, CvxMainComponent, CvxAsideLeftComponent, CvxFooterComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  protected APP_CONFIG: any = APP_CONFIG;
  protected lastSync = signal<string>('2024-10-25');

  // True when the active route is the standalone worksheet print page,
  // in which case the application shell (header/nav/footer/aside) is hidden.
  protected readonly standalone = signal<boolean>(false);
  protected readonly accessDenied = signal<boolean>(false);
  protected readonly initialNavigationPending = signal<boolean>(true);

  constructor() {
    this.authService.login();

    this.updateStandalone(this.router.url);
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.updateStandalone(e.urlAfterRedirects);
        this.initialNavigationPending.set(false);
      });
  }

  private updateStandalone(url: string): void {
    const isStandalone = url.includes('/worksheets/');
    const path = url.split(/[?#]/, 1)[0];
    const isAccessDenied = path === '/401' || path === '/403';

    this.standalone.set(isStandalone);
    this.accessDenied.set(isAccessDenied);
    document.body.classList.toggle('print-page', isStandalone);
    document.body.classList.toggle('access-denied-page', isAccessDenied);
  }
}
